import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig, isAxiosError } from 'axios';
import { baseURL } from '../utils/constants/env';
import { StorageEnum } from '../utils/enum';
import { TIME_OUT } from '../utils/constants/common';
import { getTimezone } from '../utils/helper';
import { HTTP_RESPONSE } from '../utils/constants/common';
import { adminRouteAbsolute } from '../utils/constants/route';
import i18n from '../utils/i18n';

const axiosClient = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    timeout: TIME_OUT,
});

// Add a request interceptor
axiosClient.interceptors.request.use(
    function (config: InternalAxiosRequestConfig) {
        // Do something before request is sent
        const token = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
        
        if (typeof window !== 'undefined') {
            const h = window.location.hostname;
            if (h === 'app.trogiang.online' || h.endsWith('.trogiang.online')) {
                config.baseURL = 'https://api.trogiang.online/api/v1';
            } else if (h === 'app-trogiang.icitech.net' || h.endsWith('.icitech.net')) {
                config.baseURL = 'https://api-trogiang.icitech.net/api/v1';
            }
        }

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers['LMS-Timezone'] = getTimezone();
        config.headers['Accept-Language'] = i18n.language || 'en';
        return config;
    },

    function (error: AxiosError | Error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
    function (response: AxiosResponse) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },

    function (error: AxiosError | Error) {
        // Do something with response error
        if (isAxiosError(error)) {
            // Handle Unauthorize case
            if (error?.response?.status === HTTP_RESPONSE.COMMON.UNAUTHORIZED.code) {
                localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
                localStorage.removeItem(StorageEnum.USER_INFO);
                localStorage.removeItem(StorageEnum.USER_ROLE);
                localStorage.removeItem(StorageEnum.PARENT_ACCESS_TOKEN);

                const path = typeof window !== 'undefined' ? window.location.pathname : '';
                const isPublicPath = path.startsWith('/arcade') || path.startsWith('/login') || path.startsWith('/register');
                if (!isPublicPath) {
                    setTimeout(() => {
                        window.location.href = adminRouteAbsolute.login;
                    }, 1500);
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
